/// <amd-module name="CodeCoverage/CodeCoverageSourceProvider/SourceProviderFactoryService" />
import { AzureReposProvider } from "CodeCoverage/AzureReposProvider/AzureReposProvider";
import { ISourceProvider, RepositoryTypes } from "CodeCoverage/ViewCommon/Contracts/ISourceProvider";
import { IVssService, Services, VssService, IVssPageContext } from "VSS/Platform/Context";

export interface ISourceProviderFactoryService extends IVssService {
    getSourceInfoProvider(
        pageContext: IVssPageContext,
        repositoryType: string
    ): ISourceProvider | null;
}

export class SourceProviderFactoryService extends VssService implements ISourceProviderFactoryService {
    private static _sourceProviders: { [key: string]: ISourceProvider } = {};
    public getSourceInfoProvider(
        pageContext: IVssPageContext,
        repositoryType: string
    ): ISourceProvider | null {
        repositoryType = repositoryType.toLowerCase();
        if (!SourceProviderFactoryService._sourceProviders[repositoryType]) {
            switch (repositoryType) {
                case RepositoryTypes.TfsGit:
                    SourceProviderFactoryService._sourceProviders[repositoryType] = new AzureReposProvider();
                    SourceProviderFactoryService._sourceProviders[repositoryType].initialize(pageContext);
                    break;
                default:
                    return null;
            }
        }

        return SourceProviderFactoryService._sourceProviders[repositoryType];
    }
}

Services.add("ISourceProviderFactoryService", { serviceFactory: SourceProviderFactoryService });